export interface SubDataItem {
  title: string;
  link: string | null;
}

export interface ExampleItem {
  title: string;
  subData: SubDataItem[];
}

export const ExampleDatas: ExampleItem[] = [{
  title: 'อัตรา 5%',
  subData: [{
    title: 'ค่าเช่า',
    link: 'https://www.itax.in.th/pedia/เงินได้ประเภทที่-5'
  }, {
    title: 'รางวัลจากการชิงโชคหรือการประกวดแข่งขัน',
    link: null
  }, {
    title: 'ค่าตัวนักแสดงสาธารณะ',
    link: 'https://www.itax.in.th/pedia/นักแสดงสาธารณะ'
  }]
}, {
  title: 'อัตรา 3%',
  subData: [{
    title: 'ค่าบริการ',
    link: null
  }, {
    title: 'ค่าวิชาชีพอิสระ',
    link: 'https://www.itax.in.th/pedia/เงินได้ประเภทที่-6'
  }, {
    title: 'ค่าลิขสิทธิ์',
    link: 'https://www.itax.in.th/pedia/เงินได้ประเภทที่-3'
  }]
}, {
  title: 'อัตรา 2%',
  subData: [{
    title: 'ค่าโฆษณา',
    link: null
  }]
}, {
  title: 'อัตรา 1%',
  subData: [{
    title: 'ค่าขนส่ง',
    link: null
  }, {
    title: 'ค่าบริการที่หักภาษีผ่านระบบ "e-Withholding Tax"',
    link: 'https://www.itax.in.th/pedia/e-withholding-tax-ภาษีหัก-ณ-ที่จ่าย-อิเล็กทรอนิกส์/'
  }]
}];

export interface Item {
  id: number;
  label: string;
}

export const DropdownDatas: Item[] = [{
  id: 1,
  label: 'ก่อน VAT'
}, {
  id: 2,
  label: 'รวม VAT'
}, {
  id: 3,
  label: 'หลังหักภาษี ณ ที่จ่าย'
}];

export const DefaultDropdown: Item = {
  id: 1,
  label: 'ก่อน VAT'
};

export enum CalculateType {
  beforeVat = 1,
  withVat,
  withHoldingTax
}

export const defaultValue = '0';
export const defaultTax = 3;
export const defaultVat = 7;
export const hundredPercent = 100.00;
